import ApolloLinkTimeout from 'apollo-link-timeout';
import { getSharedConfig } from '../../common/helpers/configs';

export function createTimeoutLink() {
  const sharedConf = getSharedConfig();
  return new ApolloLinkTimeout(sharedConf.timeout);
}
